import React, { Component } from 'react';
import compose from 'recompose/compose';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import { api_host,api_auth, tokenDuoc, key_auth} from '../../../../../../common/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')

highchartsMore(Highcharts);
xRange(Highcharts);

Highcharts.setOptions ({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        shortMonths: [
            'Ene', 'Feb', 'Mar', 'Abr',
            'Mar', 'Jun', 'Jul', 'Ag',
            'Sep', 'Oct', 'Nov', 'Dic'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miercoles',
            'Jueves', 'Viernes', 'Sabado'
        ],
        shortWeekdays: ['D','L' ,'M', 'Mi', 'J', 'V', 'S']
    }
}) 

class AvailabilityObjectives extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.obj.id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'd',
            hoverData: null,
            lastEvent: [],
            chartOptionsBase: this._chartOptionsBase,
            chartOptionsStackedBarConsolidated: this._chartOptionsBase,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            modalOpen: false,
            modalClose : true, 
            point: [],
            monitores: []
        }
    }
    _chartOptionsBase = {
        chart: {
            type: 'xrange'
        },
        title: {
            text: null
        },
        xAxis: {
            type: 'datetime',
            gridLineWidth: 0,
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineWidth: 0,
            reversed: true,
            labels: {
                useHTML:true,
                style:{
                    width:'100px',
                    whiteSpace:'normal'
                },
                step: 1,
                formatter: function () {
                    return '<div align="center" style="word-wrap: break-word;word-break: break-all;width:100px">' + this.value + '</div>';
                }
            },
        },
        series: [{
            pointWidth: 10,
            turboThreshold: 0,
            animation: false,
            dataLabels: {
                enabled: true
            }
        }],
       
        plotOptions: {
            series: {
                border: '0px',
                borderRadius: '0px',
                borderColor: 'transparent',
                pointWidth: 10,
                turboThreshold: 0,
                grouping: false
            }
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false,
        }
    }


    


    componentDidMount() {
        this.getDataFromAPI();
    }

    getDataFromAPI = () => {
        const {time, currentObjectiveId}=this.state
            Promise.all([
                
                fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadParcialObjetivoDowntime/?user=5012&key=${key_auth}&objetivoId=${currentObjectiveId}&horarioId=0&t=${time}&token=${tokenDuoc}&nodoId=0`)
            ])
                .then(([ res2]) => {
                    return Promise.all([res2.json()])
                })
                .then(([ res2]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if ( res2.status == 1 || res2.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(time,res2)
                        } catch (error) {
                            this.props.callbackFromParent({'obj':currentObjectiveId, 'uptime':{},'down':{},'noMon':{}, 'parcial':{}})                    
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }

    // Helper para procesar la data de la petición a la API

    processData = (
        period,
        externalDataConsolidated) => {
        const { estado } = externalDataConsolidated.Objetivo.Nodo[0]

        var name=(externalDataConsolidated.Objetivo.Objetivo_Nombre)
        let lastEventDict = []
        lastEventDict['namePeriod'] = 'Rango: último día'
    
        const colors = ['#41B900', '#C2272D', '#A9A9A9', '#FFC600'];     
       
        let dictDataStackedBarUptime = {}
        dictDataStackedBarUptime['name'] = 'Uptime'
        dictDataStackedBarUptime['pointWidth'] = 40
        let arrayDataUptime = []

        let dictDataStackedBarDowntime = {}
        dictDataStackedBarDowntime['name'] = 'Downtime'
        dictDataStackedBarDowntime['pointWidth'] = 40
        let arrayDataDowntime = []

        let dictDataStackedBarNoMon = {}
        dictDataStackedBarNoMon['name'] = 'No Monitoreo'
        dictDataStackedBarNoMon['pointWidth'] = 40
        let arrayDataNoMon = []

        let dictDataStackedBarPartial = {}
        dictDataStackedBarPartial['name'] = 'Downtime Parcial'
        dictDataStackedBarPartial['pointWidth'] = 40
        let arrayDataPartial = []

        Object.keys(estado).map((key) => {
            let dictDataStackedBar = {}

            let dateJson = new Date(estado[key]['fecha_desde'].substring(0, 19))
            let year = dateJson.getFullYear()
            let month = dateJson.getMonth()
            let day = dateJson.getDate()
            let hours = dateJson.getHours()
            let minutes = dateJson.getMinutes()
            let seconds = dateJson.getSeconds()

            let dateJsonEnd = (new Date(estado[key]['fecha_hasta'].substring(0, 19)))
            let yearEnd = dateJsonEnd.getFullYear()
            let monthEnd = dateJsonEnd.getMonth()
            let dayEnd = dateJsonEnd.getDate()
            let hoursEnd = dateJsonEnd.getHours()
            let minutesEnd = dateJsonEnd.getMinutes()
            let secondsEnd = dateJsonEnd.getSeconds()

            dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
            dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
            dictDataStackedBar['y'] = 0
            if (estado[key]['nombre'] == 'uptime') {
                dictDataStackedBar['color'] = colors[0]
                arrayDataUptime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime') {
                dictDataStackedBar['color'] = colors[1]
                arrayDataDowntime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'no monitoreo') {
                dictDataStackedBar['color'] = colors[2]
                arrayDataNoMon.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime parcial') {
                dictDataStackedBar['color'] = colors[3]
                arrayDataPartial.push(dictDataStackedBar)
            }  
        })

        dictDataStackedBarUptime['data'] = arrayDataUptime
        dictDataStackedBarDowntime['data'] = arrayDataDowntime
        dictDataStackedBarNoMon['data'] = arrayDataNoMon
        dictDataStackedBarPartial['data'] = arrayDataPartial
        //console.log(externalDataConsolidated.Objetivo)
        
        //console.log([dictDataStackedBarUptime,dictDataStackedBarDowntime ,dictDataStackedBarNoMon, dictDataStackedBarPartial])
        this.props.callbackFromParent({'obj':externalDataConsolidated.Objetivo, 'uptime':dictDataStackedBarUptime, 
        'down':dictDataStackedBarDowntime,'noMon':dictDataStackedBarNoMon, 'parcial':dictDataStackedBarPartial})
        //console.log('obj',dictDataStackedBarUptime)
        //Mods. ddiaz 26-05-2021
        dictDataStackedBarUptime.name = 'Operativo (verificado desde todos los ISP)'
        dictDataStackedBarDowntime.name = 'Caído o No Operativo.'
        dictDataStackedBarPartial.name = 'Operativo (algunos ISP con problemas)'

        this.setState({
            chartOptionsStackedBarConsolidated: {
                pane: {
                    size: '150%',
                },
                yAxis: { categories: [name]},                
        
                series: [dictDataStackedBarUptime, dictDataStackedBarDowntime, dictDataStackedBarNoMon, dictDataStackedBarPartial],
                
                legend: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    visible: false

                },
                chart: {
                    height: 85
                },
                tooltip: {
                    enabled: true,
                },
                
            },
            
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
        });

    }
    render() {
        const { classes, className, location } = this.props;
        const { dataError, chartOptionsStackedBarConsolidated,  isLoading, currentObjectiveId} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        if (!dataError) {
            return (<FormattedChart chartOptionsStackedBarConsolidated={chartOptionsStackedBarConsolidated} style={style} 
                                    styleHidden={styleHidden} 
                                    classes={classes} objective={currentObjectiveId}
                                    />
                                    )
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p>Error!</p>)

    }
}

function FormattedChart(props) {
 
    return (
        <div >
            <div style={props.styleHidden}>
                    <PerfectScrollbar>
                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"
                        size={24}
                        thickness={4}
                        />
                        <br/>
                            Cargando Información...
                        </Typography>
                    </PerfectScrollbar>
            </div>
            <HighchartsReact
                highcharts={Highcharts}
                options={props.chartOptionsStackedBarConsolidated} 
            />
            
        </div>
    )
}
export default
    compose(withStyles(styles))(AvailabilityObjectives);